export const BUILD_VERSION = 'b5ed4bb84870f0e211051f07c607fa5d450a2272';
